import ExpressionResolver from '../form/helpers/expression-resolver-store'
import { dropdownHasValue } from '../../../utils'
import { SOURCE_TYPES } from '../../../components/list-new/lib/list-constants'
import { FIELD_PROPS, FIELD_TYPES } from '../../../consts'
import { first, get, isEmpty } from 'lodash'
import { castValueTypeToMatchKeyType } from '../../../form'
import Vue from 'vue'

const DATE = 'date'
const DATE_TIME = 'datetime-local'
const DATE_FORMAT = 'YYYY-MM-DD'
const DATE_TIME_FORMAT = 'YYYY-MM-DD HH:mm:ss'

const convertDateToString = (date, format) => {
  return moment(new Date(date)).format(format)
}

const convertDateValue = (type, propToChange, value) => {
  if (propToChange !== FIELD_PROPS.VALUE) return value

  switch (type) {
    case DATE_TIME:
      value = value ? convertDateToString(value, DATE_TIME_FORMAT) : null
      break
    case DATE:
      value = value ? convertDateToString(value, DATE_FORMAT) : null
      break
  }
  return value
}

const convertDropdownValue = (type, list, value, isMultiselect) => {
  if (type === FIELD_TYPES.DROPDOWN && !isEmpty(get(list, 'options', [])) && dropdownHasValue(value)) {
    const castValue = castValueTypeToMatchKeyType(first(list.options), value)
    return isMultiselect ? castValue : first(castValue)
  }
  return value
}

export async function resolveListWithLazyLoad({ idForm, fieldId, fieldValue, contextData, externalParams }) {
  const selection = dropdownHasValue(fieldValue) ? (Array.isArray(fieldValue) ? fieldValue : [fieldValue]) : null
  const parameters = {
    sourceType: SOURCE_TYPES.FORM,
    idSource: idForm,
    fieldId,
    contextData,
    selection,
    page: 0,
  }
  const { obj } = await Vue.prototype.$client.execute({
    operationId: 'LazyLoader_bySourceType',
    parameters,
  })
  return obj
}

export const resolveFieldExpression = async ({ expression, namespace, triggerName, field, prop, getters, name }) => {
  let value
  const { id: fieldId, value: fieldValue, type, list, multiselect } = field
  if (prop === FIELD_PROPS.LIST) {
    const contextData = getters.getListExpressionContextData(name)
    const idForm = getters.mongoId
    value = await resolveListWithLazyLoad({
      idForm,
      fieldId,
      fieldValue,
      contextData,
    })
  } else {
    value = await ExpressionResolver.resolve({
      fieldState: field,
      expression,
      namespace,
      triggerName,
    })
    value = convertDateValue(type, prop, value)
    value = convertDropdownValue(type, list, value, multiselect)
  }

  return value
}

export async function getFormattedDropdownValue({ options = [], value, idForm, contextData, fieldId }) {
  const valueArray = Array.isArray(value) ? value : [value]

  if (!options.length) {
    const listValue = await resolveListWithLazyLoad({
      idForm,
      fieldId,
      fieldValue: valueArray,
      contextData,
    })

    options = get(listValue, 'options', [])
  }

  if (!options.length) return ''

  return options
    .filter(({ key }) => valueArray.includes(key))
    .map(({ value }) => value)
    .join(', ')
}

export function getSqlChosenFormattedValue(listData, relField, value) {
  return listData.filter((row) => value.includes(row.ID_VALUE)).map((row) => row[relField]) || []
}
